<template>
  <div class="consulta-page">

    <!-- ── SEÇÃO: Filtros ── -->
    <div class="form-section">
      <div class="form-section__header">
        <div class="form-section__icon-wrap">
          <v-icon color="#0052A0" size="20">mdi-filter-outline</v-icon>
        </div>
        <div>
          <div class="form-section__title">Filtros</div>
          <div class="form-section__sub">Busque consultas por período ou CPF/CNPJ</div>
        </div>
      </div>
      <div class="form-section__body">
        <v-row dense align="end">
          <v-col cols="12" md="3">
            <data-component
              v-model="dataInicial"
              labelDate="Pesquisa Inicial"
              only-date outlined dense color="#0052A0"
            />
          </v-col>
          <v-col cols="12" md="3">
            <data-component
              v-model="dataFinal"
              labelDate="Pesquisa Final"
              only-date outlined dense color="#0052A0"
            />
          </v-col>
          <v-col cols="12" md="3">
            <div class="mb-1">
              <v-radio-group v-model="row2" row class="mt-0" hide-details dense>
                <v-radio label="CPF" value="cpf" color="#0052A0" />
                <v-radio label="CNPJ" value="cnpj" color="#0052A0" />
              </v-radio-group>
            </div>
            <v-text-field
              v-model="cpf_cnpj2"
              :label="row2 === 'cpf' ? 'CPF' : 'CNPJ'"
              outlined dense color="#0052A0"
              v-if="row2 === 'cpf'"
              :rules="cpfRule2"
              v-cpf:model="cpf_cnpj2"
            />
            <v-text-field
              v-model="cpf_cnpj2"
              label="CNPJ"
              outlined dense color="#0052A0"
              v-if="row2 === 'cnpj'"
              :rules="cnpjRule"
              v-cnpj:model="cpf_cnpj2"
            />
          </v-col>
        </v-row>

        <div class="filter-actions">
          <v-btn color="#0052A0" rounded elevation="0" @click="listarConsultas" class="px-5">
            <v-icon left color="#FFD400" small>mdi-magnify</v-icon>
            <span style="color:#FFD400;font-weight:700;font-size:13px">Buscar</span>
          </v-btn>
          <v-btn color="#0052A0" rounded elevation="0" @click="abrirDialogConsulta" class="px-5">
            <v-icon left color="#FFD400" small>mdi-plus-circle</v-icon>
            <span style="color:#FFD400;font-weight:700;font-size:13px">Nova Consulta</span>
          </v-btn>
        </div>
      </div>
    </div>

    <!-- ── SEÇÃO: Tabela ── -->
    <div class="form-section form-section--last">
      <v-data-table
        :headers="[
          { text: 'CPF/CNPJ', sortable: false },
          { text: 'Consumidor', sortable: false },
          { text: 'Data Consulta', sortable: false },
          { text: 'Ações', sortable: false, align: 'center' },
        ]"
        :items="listaConsultas"
        class="consulta-table elevation-0"
        no-data-text="Sem dados"
        :footer-props="{
          'items-per-page-text': 'Registros por página: ',
          'page-text': '{0}-{1} de {2}',
          'items-per-page-all-text': 'Listar todos',
        }"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ formatarCpfCnpj(item.cpf_cnpj_consumidor) }}</td>
            <td>{{ item.nome }}</td>
            <td>{{ item.data_consulta }}</td>
            <td class="text-center">
              <v-btn icon small color="#0052A0"
                :to="{ name: 'Consulta ao Consumidor', params: { id: item.id } }"
                title="Ver detalhes"
              >
                <v-icon small>mdi-magnify</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>

    <!-- ══ DIALOG: Nova Consulta ══ -->
    <v-dialog v-model="dialogConsulta" persistent max-width="520">
      <v-card>
        <div class="dialog-header">
          <div class="dialog-header__icon-wrap">
            <v-icon color="#0052A0">mdi-account-search-outline</v-icon>
          </div>
          <div>
            <div class="dialog-header__title">Nova consulta de consumidor</div>
            <div class="dialog-header__sub">Os dados são da data de geração do documento</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogConsulta = false"><v-icon color="#64748b">mdi-close</v-icon></v-btn>
        </div>

        <v-card-text class="pa-6">
          <div class="field-group-label mb-2">Tipo de documento</div>
          <v-radio-group v-model="row" row class="mt-0 mb-4" hide-details>
            <v-radio label="CPF" value="cpf" color="#0052A0" />
            <v-radio label="CNPJ" value="cnpj" color="#0052A0" />
          </v-radio-group>

          <v-text-field
            v-model="cpf_cnpj"
            label="CPF"
            :loading="ldg_nova_consulta"
            outlined dense color="#0052A0"
            v-if="row === 'cpf'"
            :rules="cpfRule"
            v-cpf:model="cpf_cnpj"
          />
          <v-text-field
            v-model="cpf_cnpj"
            label="CNPJ"
            :loading="ldg_nova_consulta"
            outlined dense color="#0052A0"
            v-if="row === 'cnpj'"
            :rules="cnpjRule"
            v-cnpj:model="cpf_cnpj"
          />

          <div v-if="consultaGerada" class="mt-3">
            <router-link
              :to="{ name: 'Consulta ao Consumidor', params: { id: idNovaConsulta } }"
              style="color:#0052A0;font-family:Inter,sans-serif;font-size:0.85rem"
            >
              Ver consulta efetuada →
            </router-link>
          </div>
        </v-card-text>

        <v-card-actions style="border-top:1px solid #f1f5f9;padding:12px 20px;">
          <v-spacer></v-spacer>
          <v-btn text rounded color="grey darken-1" @click="dialogConsulta = false" class="mr-2">
            <v-icon left small>mdi-close</v-icon>Fechar
          </v-btn>
          <v-btn color="#0052A0" rounded elevation="0" :loading="ldg_nova_consulta" @click="criarConsulta()" class="px-6">
            <v-icon left color="#FFD400" small>mdi-check</v-icon>
            <span style="color:#FFD400;font-weight:700;font-size:13px">Efetuar Consulta</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { isCNPJ, isCPF } from "vuetify-masks-br";
import helper from "../../mixins/helper";
import DataComponent from "../../components/DataComponent";

export default {
  components: { DataComponent },
  mixins: [helper],
  data: () => ({
    row: "cpf",
    cpf_cnpj: "",
    ldg_nova_consulta: false,
    row2: "cpf",
    cpf_cnpj2: "",
    idNovaConsulta: null,
    dialogConsulta: false,
    consultaGerada: false,
    dataInicial: null,
    dataFinal: null,
    listaConsultas: [],
    search: "",
    cpfRule: [
      (v) => !!v || "CPF é obrigatório",
      (v) => isCPF(v || "") || "CPF não é válido.",
    ],
    cpfRule2: [
      (v) => !!v || "CPF é obrigatório",
      (v) => isCPF(v || "") || "CPF não é válido.",
    ],
    cnpjRule: [
      (v) => !!v || "CNPJ é obrigatório",
      (v) => isCNPJ(v || "") || "CNPJ não é válido.",
    ],
  }),
  mounted() {
    this.listarConsultas();
  },
  methods: {
    abrirDialogConsulta() {
      this.consultaGerada = false;
      this.dialogConsulta = true;
    },
    listarConsultas() {
      this.$http.post("getConsultasEmpresa", {
        dataInicial: this.dataInicial,
        dataFinal: this.dataFinal,
        cpf_cnpj: this.cpf_cnpj2,
      }).then(
        (response) => { this.listaConsultas = response.data; },
        (response) => { console.log(response); }
      );
    },
    notificacao(title, msg, icon) {
      this.$swal({ toast: true, position: "center", showConfirmButton: false, timer: 3000, icon, title, text: msg });
    },
    criarConsulta() {
      this.ldg_nova_consulta = true;
      this.$http.post("VerificarConsultaRecorrenteConsumidor", { cpf_cnpj: this.cpf_cnpj }).then(
        (response) => {
          this.ldg_nova_consulta = false;
          if (response.data === '"1"') {
            this.requisicarConsuta();
          } else {
            this.notificacao("Aviso", response.data, "warning");
          }
        },
        (response) => { this.ldg_nova_consulta = false; console.log(response); }
      );
    },
    requisicarConsuta() {
      this.ldg_nova_consulta = true;
      this.$http.post("consultarConsumidor", { cpf_cnpj: this.cpf_cnpj }).then(
        (response) => {
          this.idNovaConsulta = response.data.protocolo_consulta;
          this.consultaGerada = true;
          this.notificacao("Sucesso", "Busca realizada com sucesso", "success");
          this.listarConsultas();
          this.ldg_nova_consulta = false;
        },
        (response) => { this.ldg_nova_consulta = false; console.log(response); }
      );
    },
    getDataInicial(data) { this.dataInicial = data; },
    getDataFinal(data) { this.dataFinal = data; },
  },
};
</script>

<style scoped>
.consulta-page {
  background: #fff;
  min-height: calc(100vh - 64px);
  padding: 28px 32px;
  width: 100%;
  box-sizing: border-box;
}

.form-section {
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 32px;
  margin-bottom: 32px;
}
.form-section--last { border-bottom: none; padding-bottom: 0; margin-bottom: 0; }
.form-section__header {
  display: flex; align-items: flex-start; gap: 12px; padding: 0 0 18px 0;
}
.form-section__icon-wrap {
  width: 34px; height: 34px; background: #e8f0fe; border-radius: 8px;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.form-section__title { font-family: 'Inter', sans-serif; font-size: 0.92rem; font-weight: 700; color: #1e293b; }
.form-section__sub { font-family: 'Inter', sans-serif; font-size: 0.78rem; color: #94a3b8; margin-top: 1px; }
.form-section__body { padding: 0; }

.filter-actions { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 8px; }
@media (max-width: 600px) {
  .filter-actions > .v-btn { flex: 1 1 auto; min-width: 0 !important; }
}

.field-group-label {
  font-family: 'Inter', sans-serif; font-size: 0.7rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.8px; color: #94a3b8;
}

.consulta-table >>> th {
  font-family: 'Inter', sans-serif !important; font-size: 0.72rem !important;
  font-weight: 700 !important; color: #64748b !important;
  text-transform: uppercase; letter-spacing: 0.5px;
  background: #f8fafc !important; padding: 10px 12px !important;
}
.consulta-table >>> td {
  font-family: 'Inter', sans-serif !important; font-size: 0.85rem !important;
  color: #1e293b !important; font-weight: 400 !important;
  padding: 10px 12px !important; border-bottom: 1px solid #f1f5f9 !important;
}

.dialog-header {
  display: flex; align-items: center; gap: 12px;
  padding: 20px 24px; border-bottom: 1px solid #f1f5f9;
}
.dialog-header__icon-wrap {
  width: 36px; height: 36px; background: #e8f0fe; border-radius: 8px;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.dialog-header__title { font-family: 'Inter', sans-serif; font-size: 0.95rem; font-weight: 700; color: #1e293b; }
.dialog-header__sub { font-family: 'Inter', sans-serif; font-size: 0.78rem; color: #94a3b8; margin-top: 2px; }

.consulta-page >>> .v-input__slot { background-color: #fff !important; box-shadow: none !important; }
.consulta-page >>> .v-label { font-family: 'Inter', sans-serif !important; font-size: 0.85rem !important; }

@media (max-width: 768px) { .consulta-page { padding: 16px; } }
</style>
